module.exports = __webpack_public_path__ + "img/create-new-reg-type.c6df6417.svg";